import React from "react";
import { EuiModal, EuiModalBody } from "@elastic/eui";

type FDFullScreenProps = { children: React.ReactNode; onClose: () => void };

const FDFullScreen: React.FunctionComponent<FDFullScreenProps> = ({ children, onClose }) => {
  return (
    <>
      <EuiModal className="fullscreen_modal" onClose={onClose}>
        <EuiModalBody style={{ background: "var(--card-background)" }}>
          <div className="fullscreen">{children}</div>
        </EuiModalBody>
      </EuiModal>
    </>
  );
};

export default FDFullScreen;
